<template>
  <b-card class="w-100" body-class="d-flex flex-grow-1 flex-column" v-loading="loading" :element-loading-text="loadingText" :data-block-disabled="!loading ? 'Coming Soon!' : ''">
    <div>
      <h4>
        <img src="/img/publishers/craigslist.png" height="50" alt="Craigslist" />
        <small v-if="!loading" class="pull-right">
          <b-badge v-if="account.active" variant="success">ACTIVE</b-badge>
          <b-badge v-else variant="danger">INACTIVE</b-badge>
        </small>
      </h4>

      <div v-if="!loading" class="mt-4">
        <div v-if="account.active">
          <h5>Full Name</h5>
          <p v-if="account.name">{{account.name}}</p>
          <p v-else><em>(empty)</em></p>

          <h5>Email Address</h5>
          <p>{{account.username}}</p>
        </div>
        <b-form v-else>
          <b-form-group label="Email Address or Nickname">
            <b-form-input v-model="account.username" type="email" placeholder="eg. someone@example.com" required autocomplete="email"></b-form-input>
          </b-form-group>
          <b-form-group label="Password">
            <b-form-input v-model="account.password" type="password" placeholder="your password" required autocomplete="current-password"></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </div>

    <div v-if="!loading" class="mt-4">
      <div v-if="account.active">
        <p class="mb-2">To change your login details, you must log out and reconnect</p>
        <b-button size="lg" variant="danger" @click="logout()">Logout &amp; Reconnect</b-button>
      </div>
      <div v-else>
        <p class="small">By clicking login below you authorize us to post your listings on Craigslist on your behalf as well as periodically collect advertisement statistics from your  We will <strong>never</strong> post anything on your account without your explicit consent. AdReplay&reg; does not store your account credentials after completing the login.</p>
        <b-button type="submit" size="lg" variant="primary" @click="login()">Login to Craigslist</b-button>
      </div>
      <b-alert :show="!!error" fade variant="danger" class="mt-4 mb-0">{{error}}</b-alert>
    </div>
  </b-card>
</template>

<script>
const LoadingText = 'Checking Craigslist Account Status...'
const UnlinkingText = 'Disconnecting Craigslist Account...'
const LinkingText = 'Connecting Craigslist Account...'

export default {
  name: 'PublishersCraigslist',

  data(){
    return {
      account : {},

      // State
      loading     : false,
      loadingText : LoadingText,
      error       : ''
    }
  },

  mounted(){
    // this.load()
  },

  methods: {
    load(){
      this.loading = true
      this.loadingText = LoadingText
      this.$API.v2.Publishers.Craigslist.Get()
      .then((kijiji) => {
        this.account = kijiji
        this.error = ''
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
    },

    logout(){
      // @TODO confirm unlinking

      this.loading = true
      this.loadingText = UnlinkingText
      this.$API.v2.Publishers.Craigslist.Disconnect()
      .then(() => {
        this.account = {}
        this.error = ''
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
    },

    login(){
      const { username, password } = this.account

      this.loading = true
      this.loadingText = LinkingText
      this.$API.v2.Publishers.Craigslist.Connect(username, password)
      .then((kijiji) => {
        this.account = kijiji
        this.error = ''
      })
      .catch((err) => {
        this.error = err
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.text-grey {
  color: #464646;
}
</style>
